import CdnMixin from '@SHARED/js/Vue/mixins/CdnMixin';
import template from './EmployeesField.html';
import MediaGalleryModule from '../../MediaGallery/MediaGalleryModule';

export default {
  name: 'EmployeesField',

  template,

  mixins: [CdnMixin],

  components: {
    MediaGalleryModule,
  },

  props: {
    relatedId: {
      type: Number,
      required: true,
    },
    relatedModel: {
      type: String,
      required: true,
    },
    initContent: {
      type: Object,
      required: true,
      default: {
        departmentTitle: '',
        employees: [],
      },
    },
    uniqueId: String,
  },

  data() {
    return {
      content: this.initContent,
      renderGallery: false,
    };
  },

  created() {
    this.validateContent(this.initContent);
  },


  // Methods

  methods: {
    addEmployee(employeeIndex = null) {
      if (employeeIndex !== null && typeof this.content.employees[employeeIndex] !== 'undefined') {
        this.content.employees.splice(++employeeIndex, 0, this.createEmployee());
      } else if (employeeIndex === null || this.content.employees.length === 0) {
        this.content.employees.push(this.createEmployee());
      }
    },

    createEmployee(data = {}) {
      return {
        media: !_.isEmpty(data.media) ? data.media : null,
        name: !_.isEmpty(data.name) ? data.name : null,
        title: !_.isEmpty(data.title) ? data.title : null,
        phone: !_.isEmpty(data.phone) ? data.phone : null,
        email: !_.isEmpty(data.email) ? data.email : null,
      };
    },

    openGalleryModal(employeeIndex) {
      this.renderGallery = true;

      // Make sure gallery is rendered first, then bind event 'insertGallery'
      this.$nextTick(() => {
        this.$refs.galleryComponent.initOnFroalaEditor();

        this.$refs.galleryComponent.$once('insert-gallery', ({ media }) => {
          this.attachMediaFromGallery(employeeIndex, media);
        });

        this.$refs.galleryComponent.$once('destroy-gallery', () => {
          // Remove 'insertGallery' event in case gallery was closed without firing 'insertGallery'
          this.$refs.galleryComponent.$off('insert-gallery');
        });
      });
    },

    attachMediaFromGallery(employeeIndex, media) {
      try {
        media.forEach((mediaItem) => {
          if (mediaItem.file_type === 'image') {
            this.content.employees[employeeIndex].media = mediaItem;
          }
        });
      } catch (err) {
        throw new Error(err);
      }

      this.$refs.galleryComponent.destroyGallery();

      this.$nextTick(() => {
        this.renderGallery = false;
      });
    },

    removeEmployee(employeeIndex) {
      if (typeof this.content.employees[employeeIndex] !== 'undefined') {
        this.content.employees.splice(employeeIndex, 1);
      }
    },

    validateContent(content) {
      if (!Array.isArray(content.employees) || typeof content.departmentTitle === 'undefined') {
        throw new Error('Invalid content given to EmployeesField');
      }

      return true;
    },

  },
};
